import React, { useState } from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { Navigate, useParams } from 'react-router';

import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';

import { RootState } from '../../../../app/rootReducer';
import { IconLink } from '../../../../common/components/IconLink';
import { Resource } from '../../../../common/constants/resource';
import ElementLocators from '../../../../common/ElementLocators';
import { tasksResolved } from '../../../../common/helpers';
import { DeclineDrawer } from '../../../detail/drawer/decline/DeclineDrawer';
import { InvalidDrawer } from '../../../detail/drawer/InvalidDrawer';
import { ITask } from '../../../tasks/interfaces/ITask';
import { getAllTasks } from '../../../tasks/slice/taskListSlice';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

const DeclineApplication = ({}: {}) => {
  const tasks: ITask[] = useSelector(state => getAllTasks(state.taskList));

  const copy = Resource.DECLINE_APPLICATION_HEADER;

  // For controlling the DeclineDrawer component
  const [isOpen, setIsOpen] = useState(false);
  const isValid = tasksResolved(tasks);

  const { id } = useParams<{ id: string }>();
  if (id === undefined) {
    return <Navigate to={{ pathname: '/' }} />;
  }

  return (
    <>
      {!isValid && (
        <InvalidDrawer isOpen={isOpen} setIsOpen={setIsOpen} labelCopy={copy} />
      )}
      {isValid && (
        <DeclineDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          applicationId={id}
        />
      )}
      <IconLink
        onClick={() => setIsOpen(true)}
        icon={faTimes}
        copy={copy}
        locator={ElementLocators.DECLINE_DECISION_LINK}
      />
    </>
  );
};

export default DeclineApplication;
